// Notification bell: unread badge, dropdown list, mark-all-read, realtime updates.
import { html, render } from '../utilities/html.js';
import { relativeTime } from '../utilities/dates.js';
import { listNotifications, markRead, unreadCount, subscribeToNotifications } from '../api/notifications.api.js';
import { wirePopover } from './popover.js';
import { toast, skeletonRows, emptyState } from './feedback.js';
import { setState, getState } from '../state.js';

export function notificationsMenu(root, userId) {
  const trigger = root.querySelector('[data-action="notifications"]');
  const panel = root.querySelector('[data-notifications-panel]');
  const badgeEl = root.querySelector('[data-unread]');

  const paintBadge = (n) => {
    badgeEl.hidden = n <= 0;
    badgeEl.textContent = n > 99 ? '99+' : String(n);
    trigger.setAttribute('aria-label', n > 0 ? `Notifications, ${n} unread` : 'Notifications');
  };

  async function refreshCount() {
    try {
      const n = await unreadCount();
      setState({ unreadCount: n });
      paintBadge(n);
    } catch { /* keep last value */ }
  }

  async function load() {
    render(panel, html`<div class="notif-panel__head"><strong>Notifications</strong></div>${skeletonRows(3)}`);
    try {
      const { data } = await listNotifications({ pageSize: 8 });
      render(panel, html`
        <div class="notif-panel__head">
          <strong>Notifications</strong>
          <button class="btn btn--ghost btn--sm" type="button" data-mark-all ${getState().unreadCount ? '' : 'disabled'}>Mark all read</button>
        </div>
        ${data.length ? html`<div class="notif-panel__list">${data.map((n) => html`
          <div class="notif-item ${n.read_at ? '' : 'notif-item--unread'}">
            <span class="notif-item__title">${n.title}</span>
            ${n.body ? html`<span class="text-muted">${n.body}</span>` : ''}
            <span class="notif-item__time">${relativeTime(n.created_at)}${n.link ? html` · <a href="${n.link}">Open</a>` : ''}</span>
          </div>`)}</div>`
          : emptyState({ title: 'You’re all caught up', message: 'New notifications will appear here.', iconName: 'bell' })}
        <div class="card__footer" style="padding:var(--space-3) var(--space-4)"><a href="/notifications" class="text-sm">View all notifications</a></div>`);
      panel.querySelector('[data-mark-all]')?.addEventListener('click', async () => {
        try { await markRead(null); await refreshCount(); await load(); } catch (e) { toast(e.message, { type: 'error' }); }
      });
    } catch (e) {
      render(panel, html`<div class="card__body text-sm text-danger">${e.message ?? 'Could not load notifications.'}</div>`);
    }
  }

  wirePopover(trigger, panel, { onOpen: load });
  refreshCount();
  const unsubscribe = subscribeToNotifications(userId, (n) => {
    refreshCount();
    toast(n.title, { type: 'info' });
  });
  document.addEventListener('ngw:notifications-changed', refreshCount);
  return () => { unsubscribe(); document.removeEventListener('ngw:notifications-changed', refreshCount); };
}
